import React from "react";
import { useNavigate } from "react-router-dom";
import { useMemberAuth } from "./memberAuth";

export default function RequireMember({ children }) {
  const { account, loading } = useMemberAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!loading && !account) navigate("/account/login", { replace: true });
  }, [loading, account, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--twr-warm-white)]/55">
        Loading…
      </div>
    );
  }
  if (!account) return null;
  return children;
}
